<template>
<div class="aaEnrollment">
    <div class="signup-header">
        <div class="signup-btn" @click="addSginUp">
            <van-icon name="add-o" /><span>新增报名用户</span>
        </div>
    </div>
    <div class="signup-detail" v-if="tableData.length">
        <van-checkbox-group v-model="item.checked" @change="setSelected" :max="total">
            <div class="signup-summary" v-for="(obj,index) in tableData" :key="index">
                <van-checkbox shape="square" checked-color="#0ABF53" :name="obj" @click="checkSelected">
                    <div class="user-detail">
                        <div class="name">{{obj.joinername}}</div>
                        <div class="tel">{{obj.joinermobile}}</div>
                    </div>
                </van-checkbox>
                <div class="edit" @click="editEnrollment(obj)"><van-icon name="edit" /></div>
            </div>
        </van-checkbox-group>
        <!--<label v-for="(obj,index) in tableData" :key="index">-->
            <!--<input type="checkbox" name="items" :value="obj.joinername" @click="setChecked(obj, obj.checked)" :checked="obj.checked">-->
            <!--{{obj.joinername}}-->
        <!--</label>-->
    </div>
    <div style="height: 1rem; background: #F5F7FA"></div>
    <div class="signadd-btn">
        <div class="btn cancel" @click="cancelBack">取消</div>
        <div class="btn ok" @click="submit">确定</div>
    </div>
</div>
</template>

<script>
import {getEnrollEventTicketUser} from 'api/activeTools'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'aaEnrollment',
    data() {
        return {
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : ''
            },
            tableData: [],
            item: {
                checked: []
            },
            iscollectenrollinfo: '', // 是否开启名单收集
            allticketcount: '' // 添加的人数
        }
    },
    props: ['collectinfo'],
    mounted() {
        this.getList()
    },
    methods: {
        checkSelected() {
            if (this.total === this.item.checked.length) {
                this.$toast.fail(`只能选择${this.total}位报名用户`)
            }
        },
        setSelected() {
        },
        setChecked(obj) {
            obj.checked = !obj.checked
            console.log(obj.checked)
            if (obj.checked) {
                this.item.checked.push(obj)
            } else {
                this.item.checked.forEach((obj2, index) => {
                    if (obj.joininerid === obj2) {
                        this.item.checked.splice(index, 1)
                    }
                })
            }
            console.log(this.item.checked)
        },
        openDialog(allticketcount, iscollectenrollinfo) {
            this.allticketcount = allticketcount
            this.iscollectenrollinfo = iscollectenrollinfo
            this.getList()
        },
        editEnrollment(obj) {
            this.setIsInit(true)
            this.$router.push({name: 'AaSginUpAdd', query: {eventid: this.param.eventid, joininerid: obj.joininerid}})
        },
        addSginUp() {
            this.setIsInit(true)
            this.$router.push({name: 'AaSginUpAdd', query: {eventid: this.param.eventid}})
        },
        cancelBack() {
            this.setAaEnrollment(false)
            this.$emit('closeEnrollment')
        },
        submit() {
            this.setAaEnrollmentList(this.item.checked)
            this.cancelBack()
        },
        getList() {
            getEnrollEventTicketUser({
                data: this.param,
                success: data => {
                    this.item.checked = []
                    this.tableData = data.data.list
                    this.tableData.forEach(obj => {
                        this.$set(obj, 'checked', false)
                        this.aaEnrollmentList.forEach(obj2 => {
                            if (obj.joininerid === obj2.joininerid) {
                                this.item.checked.push(obj)
                                this.$set(obj, 'checked', true)
                            }
                        })
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setInitAaEnrollment',
            'setAaEnrollment',
            'setIsInit',
            'setAaEnrollmentList'
        ])
    },
    filters: {},
    watch: {
        initAaEnrollment() {
            if (this.initAaEnrollment) {
                this.getList()
                this.setInitAaEnrollment(false)
            }
        }
    },
    computed: {
        total() {
            let tmp = 1
            if (this.collectinfo.iscollectenrollinfo) {
                tmp = this.collectinfo.allticketcount
            } else {
                tmp = 1
            }
            return tmp
        },
        ...mapGetters([
            'initAaEnrollment',
            'aaEnrollment',
            'aaEnrollmentList'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.aaEnrollment {
    background: $c-global;
    position: absolute;
    top: 0;
    left: 0;
    bottom:0;
    right:0;
    z-index: 10;
    padding-bottom: 1.1rem;
    .signup-header{
        height: 1rem;
        .signup-btn{
            margin-top: 0 !important;
            background: #fff;
            color: #0ABF53;
            font-size: 0.28rem;
            height: 1rem;
            @include flexBox(center);
            position: fixed;
            top:0;
            left: 0;
            right: 0;
            z-index: 12;
            .van-icon{
                font-size: 0.32rem;
                margin-right: 0.12rem;
            }
        }
    }
    .signup-detail{
        margin-top: 0.24rem;
        background: #fff;
        padding: 0.3rem 0.32rem;
        font-size: 0.3rem;
        .van-checkbox{
            @include flexBox(space-between);
            .van-checkbox__label{
                flex-grow: 1;
            }
        }
        .user-detail{
            @include flexBox(space-between);
            .tel{
                flex-grow: 1;
            }
            .name{
                width: 1.8rem;
                min-width: 1.8rem;
                max-width: 1.8rem;
            }
        }
    }
    .signup-summary{
        @include flexBox(space-between);
        .edit{
            text-align: right;
            flex-grow: 1;
            .van-icon-edit{
                color: #999999;
            }
        }
    }
    .signup-summary:nth-child(1){
        margin-top: 0 !important;
    }
    .signup-summary+.signup-summary{
        margin-top: 0.6rem !important;
    }
    .signadd-btn{
        position: fixed;
        bottom: 0;
        left:0;
        right:0;
        height: 1.1rem;
        @include flexBox(space-between);
        background:#fff;
        box-shadow:2px 0px 4px 0px rgba(0,0,0,0.1);
        padding: 0 0.32rem;
        .btn{
            width: 3.27rem;
            height: 0.78rem;
            line-height: 0.78rem;
            text-align: center;
            border-radius:0.4rem;
            font-size: 0.32rem;
            box-sizing: border-box;
        }
        .cancel{
            color: #0ABF53;
            border: 0.01rem solid #0ABF53;
        }
        .ok{
            color: #fff;
            background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
        }
    }
}
</style>
